/**
 * Module dependencies
 */
import { Button } from 'react-bootstrap';

/**
 * Styles
 */
import './index.scss';

/**
 * Download component
 */
function Download() {
  return (
    <Button className='Download' href={`${process.env.REACT_APP_APPLE_STORE_URL}`} target='_blank'>
      Download for free
    </Button>
  );
}

/**
 * Expose component
 */
export default Download;
